import React, { useState } from 'react';
import {
    Route as ReactRouterRoute,
    Routes as ReactRouterRoutes,
} from 'react-router-dom';
import { Route } from '../../../../types';
import { DPage } from '../../../dum';
import { SUpsertAccountDialog } from '../../../smart';
import { AccountPage } from './account/account-page';
import { AccountsPage } from './accounts/accounts-page';
import { DFab } from '../../../dum/simple/button/d-fab';

const productsPages: Route[] = [
    {
        name: 'AccountsPage',
        path: '/',
        component: <AccountsPage />,
        title: 'Cuentas',
        navbar: false,
    },
    {
        name: 'AccountPage',
        path: '/:accountId',
        component: <AccountPage />,
        title: 'Cuenta',
        navbar: false,
    },
];

export function AccountsHomePage() {
    const [accountUpsertDialog, setAccountUpsertDialog] = useState(false);

    return (
        <DPage>
            <DFab
                onClick={() => {
                    setAccountUpsertDialog(true);
                }}
            />
            <ReactRouterRoutes>
                {productsPages.map((page, index) => {
                    return (
                        <ReactRouterRoute
                            path={page.path}
                            element={page.component}
                            key={index}
                        />
                    );
                })}
            </ReactRouterRoutes>
            <SUpsertAccountDialog
                open={accountUpsertDialog}
                setOpen={setAccountUpsertDialog}
            />
        </DPage>
    );
}
